import { SUGGESTED_FIELD_FETCH_REQUEST } from 'store/constants/suggestedFieldTypes';

export function fetchSuggestedFields({ search }: any) {
  return {
    type: SUGGESTED_FIELD_FETCH_REQUEST,
    payload: { search },
  };
}
